import { styled } from 'buttered';

export let Mark = styled('mark')<{ color?: string }>`
  background: none;
  color: ${p => p.color || 'var(--vapor-primary)'};
`;
